/*
 * @Author: Code-HHX
 * @Date: 2022-03-24 11:49:13
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-03-24 12:17:43
 * @Description:
 */
import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import api from "@/api";
import { BluetoothStore } from "@/store/bluetooth";
import {
  KEY_LOCAL_STORAGE_SKIP_LOGIN,
  KEY_LOCAL_STORAGE_TOKEN,
  KEY_LOCAL_STORAGE_USERINFO
} from "./config/LocalStoreKey";
import { WriterSetting } from "./bluetooth/BluetoothData";
import { NfcStore } from "@/store/nfc";
import writer from "@/api/writer";

Vue.use(Vuex);

export default new Vuex.Store({
  state    : {
    userInfo         : {},
    skipLogin        : (() => {
      return localStorage.getItem(KEY_LOCAL_STORAGE_SKIP_LOGIN) === "true" || false;
    })(),
    curveModes       : null,
    diySetting       : (() => {
      let setting      = new WriterSetting();
      setting.id       = 0;
      setting.modeName = "DIY";

      try {
        const saveSetting      = JSON.parse(localStorage.getItem("writer_setting"));
        if (saveSetting != null) {
          console.log(`saveSetting = ${saveSetting}`);
          saveSetting.modeName = "DIY"
          saveSetting.diyVoltage = saveSetting.diyVoltage.map(item => -1 * Math.abs(item));
          if (saveSetting.outputDurationValue === 0) {
            saveSetting.outputDurationValue = 1000;
          }
          setting = { ...setting, ...saveSetting };
        }

      } catch (e) {
        console.log(e);
      }


      console.log(`result setting = ${setting}`)
      return setting;
    })(),
    brandInfo        : (() => {
      try {
        return JSON.parse(localStorage.getItem("nfc_brand_info"));
      } catch (e) {
        return null;
      }
    })(),
    brandInfoCacheMap: (() => {
      try {
        return JSON.parse(localStorage.getItem("nfc_brand_info_cache"));
      } catch (e) {
        return {};
      }
    })(),
    lastTagId        : (() => {
      try {
        return localStorage.getItem("tag_id");
      } catch (e) {
        return null;
      }
    })(),
    lastFlag         : (() => {
      try {
        return localStorage.getItem("flag");
      } catch (e) {
        return null;
      }
    })(),

    oilQrcode: "",
    cartridgeId: ""
  },
  mutations: {
    setOilQrCode(state,payload) {
      state.oilQrcode = payload
    },
    setTagId(state, payload) {
      state.lastTagId = payload;
      localStorage.setItem("tag_id", payload);
    },
    setCartridgeId(state, payload) {
      state.cartridgeId = payload;
      localStorage.setItem("cartridgeId", payload);
    },
    setFlag(state, payload) {
      state.lastFlag = payload;
      localStorage.setItem("flag", payload);
    },
    setSkipLogin(state, payload) {
      if (payload === "") {
        localStorage.removeItem(KEY_LOCAL_STORAGE_SKIP_LOGIN);
        state.skipLogin = false;
        return;

      }
      localStorage.setItem(KEY_LOCAL_STORAGE_SKIP_LOGIN, payload);
      state.skipLogin = payload;
    },
    setLoginInfo(state, payload) {
      state.userInfo = payload;
      localStorage.setItem(KEY_LOCAL_STORAGE_USERINFO, JSON.stringify(payload));
    },
    setToken(state, payload) {
      if (payload) {
        localStorage.setItem(KEY_LOCAL_STORAGE_TOKEN, payload);
      } else {
        localStorage.setItem(KEY_LOCAL_STORAGE_TOKEN, "");
      }
    },
    setCurveModes(state, payload) {
      if (payload) {
        state.curveModes = [].concat(
          payload.map((item) => {
            const setting            = new WriterSetting();
            setting.id               = item.id;
            setting.diyVoltage       = item.heatingVoltage
              .split(",")
              .map((item) => parseInt(item) * -1);
            setting.isSupportNfc     = item.nfcSettings === 1;
            setting.isSupportPreheat = item.preheatSetting === 1;
            setting.modeName         = item.modeName;
            setting.preheatTime      = item.preheatTime;
            setting.preheatVoltage   = item.preheatVoltage;
            setting.heatingRemarks   = item.heatingRemarks;
            return setting;
          })
        );
      } else {
        state.curveModes = payload;
      }
    },
    setDiySetting(state, payload) {
      payload.id         = 0;
      payload.modeName   = "DIY";
      payload.diyVoltage = payload.diyVoltage.map((item) => item * -1);
      state.diySetting   = payload;
    },
    setBrandInfo(state, payload) {
      const brandInfo = Object.assign({}, payload);
      state.brandInfo = brandInfo;
      delete brandInfo.deviceType;
      if (payload) {
        window.localStorage.setItem("nfc_brand_info", JSON.stringify(payload));
      }
    },
    setBrandInfoInMem(state, payload) {
      const brandInfo = Object.assign({}, payload);
      state.brandInfo = brandInfo;
      delete brandInfo.deviceType;
    },
    setBrandInfoCacheMap(state, payload) {
      const currentBrand          = Object.assign({}, state.brandInfoCacheMap);
      currentBrand[payload.tagId] = payload;

      console.log(`currentBrand = ${JSON.stringify(currentBrand)}`);
      state.brandInfoCacheMap = currentBrand;

      window.localStorage.setItem("nfc_brand_info_cache", JSON.stringify(currentBrand));
    }
  },
  actions  : {
    //#region 登录缓存用户信息和token
    async login({ dispatch, commit }, payload) {
      // //保存token
      commit("setLoginInfo", payload);
      commit("setToken", payload.token);
    },
    //#endregion

    //#region 授权令牌无效，请重新登录
    async logout({ commit }, payload) {
      //清空用户信息
      commit("setLoginInfo", null);
      commit("setToken", "");
      commit("setSkipLogin", "");
      commit("setCurveModes", null);
    },
    //#endregion

    async tokenExpired({ commit }) {
      //清空store
      commit("setLoginInfo", null);
      commit("setToken", "");
      commit("setCurveModes", null);
      //清空缓存F
      localStorage.clear();
      router.replace({
        name: "Login" //返回首页
      });
    },

    //请求用户的曲线设置
    async loadWriterCurves({ commit }, payload) {
      commit("setCurveModes", payload);
    },

    async loadDeviceInfo({ state, commit }, tagId) {

      try {
        // if (!(navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1)) {
        //   let tagIdSize = tagId.length / 2;
        //   let tagIdList = [];
        //   for (let i = 0; i < tagIdSize; i++) {
        //     tagIdList.push(tagId.slice(i * 2, i * 2 + 2));
        //   }
        //   tagId = tagIdList.reverse().join("").toUpperCase();
        // }
        const result    = await writer.productInfo(tagId);
        const brandInfo = {
          tagId      : tagId,
          supplierId : result.supplierId,
          brandCover : result.companyIcon,
          brandName  : result.brandName,
          deviceType : result.deviceType,
          flavor     : result.flavor,
          flavorImage: result.flavorImage
        };
        commit("setBrandInfoCacheMap", brandInfo);
        commit("setBrandInfo", brandInfo);
      } catch (e) {

      }
    }
  },
  getters  : {
    getCurveModes(state) {
      return state.curveModes;
    },

    getDiySetting(state) {
      return state.diySetting;
    }
  },
  modules  : {
    bluetooth: BluetoothStore,
    nfc      : NfcStore
  }
});
